/**
 * @generated SignedSource<<3b2e069f6370fee03ce2bff1bb0527ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksCftSubpageConfigQuery$variables = Record<PropertyKey, never>;
export type hooksCftSubpageConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type hooksCftSubpageConfigQuery = {
  response: hooksCftSubpageConfigQuery$data;
  variables: hooksCftSubpageConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_plus_cft_subpage"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_plus_cft_subpage\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksCftSubpageConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hooksCftSubpageConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5750d747ec08b29a8deb4667311b5f68",
    "id": null,
    "metadata": {},
    "name": "hooksCftSubpageConfigQuery",
    "operationKind": "query",
    "text": "query hooksCftSubpageConfigQuery {\n  appConfig(filter: {entityId: \"scmp_plus_cft_subpage\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "73e33db6da96e533b1b3a86ca6b30909";

export default node;
